import { Block } from '@ttab/elephant-api/newsdoc'

const NPK_UNIT = '/redaktionen-npk'
const ORG_NTB = 'core://org/ntb'
const ORG_TT = 'core://org/tt'

/**
 * Derives the default `core/content-source` link for a new document from the
 * session's `org` claim and `units`. NPK is keyed on the unit membership
 * (matches `buildAcl()` in `shared/Repository.ts`).
 *
 * Returns `undefined` when neither claim identifies a known source — callers
 * can then decide whether to omit the link or fall back to something else.
 *
 * The uri scheme follows the organisation, since each created its own content
 * sources: TT's are `tt://content-source/*` and NTB's `core://content-source/*`.
 * TT keeps `tt://`, which is what every TT document already carries. NPK is a
 * branch of NTB and uses NTB's. Hardcoded until this is configuration.
 */
export function getContentSourceLink({
  org,
  units
}: {
  org?: string
  units?: string[]
}): Block | undefined {
  if (units?.includes(NPK_UNIT)) {
    return buildSource('core', 'npk', 'NPK')
  }

  if (org === ORG_NTB) {
    return buildSource('core', 'ntb', 'NTB')
  }

  if (org === ORG_TT) {
    return buildSource('tt', 'tt', 'TT')
  }

  return undefined
}

function buildSource(scheme: 'tt' | 'core', slug: string, title: string): Block {
  return Block.create({
    type: 'core/content-source',
    rel: 'source',
    uri: `${scheme}://content-source/${slug}`,
    title
  })
}
